import { makeStyles } from "@mui/styles";
import classnames from "classnames";

const styles = {
    root: {},
    xs: {
        width: 18
    },
    sm: {
        width: 24
    },
    md: {
        width: 30
    },
    lg: {
        width: 38
    },
    xl: {
        width: 46
    },
    xxl: {
        width: 54
    }
};
const useStyles = makeStyles(styles);
const IconSmall = (props) => {
    const classes = useStyles();
    const { xs, sm, md, lg, xl, xxl, color = "orange", ...rest } = props;
    return (
        <svg
            viewBox="0 0 22 23"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            preserveAspectRatio="xMidYMid meet"
            className={classnames(
                classes.root,
                classes.sm,
                xs && classes.xs,
                md && classes.md,
                lg && classes.lg,
                xl && classes.xl,
                xxl && classes.xxl,
                props.className
            )}
            {...rest}
            style={{ color }}
        >
            <path d="M10.9997 0.957367H0.457031V2.88212H10.9997C15.7584 2.88212 19.6175 6.75098 19.6175 11.5C19.6175 16.2587 15.7487 20.1179 10.9997 20.1179H2.38179V6.69295H10.9997C13.6498 6.69295 15.8067 8.84983 15.8067 11.5C15.8067 14.1502 13.6498 16.3071 10.9997 16.3071H6.19261V10.5425H10.9997C11.5316 10.5425 11.9572 10.9777 11.9572 11.5C11.9572 12.032 11.522 12.4575 10.9997 12.4575H8.13671V14.3823H10.9997C12.5859 14.3823 13.882 13.0862 13.882 11.5C13.882 9.91377 12.5859 8.6177 10.9997 8.6177H4.27753L4.26786 18.2318H10.9997C14.7138 18.2318 17.7315 15.2141 17.7315 11.5C17.7315 7.7859 14.7138 4.76819 10.9997 4.76819H0.466704L0.457031 22.0426H10.9997C16.8126 22.0426 21.5423 17.313 21.5423 11.5C21.5423 5.68704 16.8126 0.957367 10.9997 0.957367Z"></path>
        </svg>
    );
};

export default IconSmall;
